import {getRootStore} from '../../../app.bootstrap';
import {getAppTracer} from '../../../../app.tracer';
import {IRouteStore} from '../../../router/routing.infra';
import {getDashboardStores} from '../dashboard.stores';

const trace = getAppTracer('DashboardMainLoader');

export interface IDashboardMainStore extends IRouteStore {
    controller: any;
    isMobile: boolean;
}

export async function dashboardMainLoader(): Promise<IDashboardMainStore> {
    trace.info('Dashboard main loader starting');
    const rootStore = getRootStore();

    await rootStore.initRootServicesCompleted;

    const dashboardStores = getDashboardStores();
    const controller = dashboardStores.dashboardMainController;
    const isMobile = rootStore.environmentService.isMobile(rootStore.displayTabletAsDesktop);

    trace.info('Dashboard main loader completed');

    return {
        controller,
        isMobile,
        dispose(): void {
            // Controller disposal is handled by DashboardStores.dispose()
        }
    };
}
